export const authConstants = {
  LOGIN_REQUEST: "AUTH_LOGIN_REQUEST",
  LOGIN_SUCCESS: "AUTH_LOGIN_SUCCESS",
  LOGIN_FAILURE: "AUTH_LOGIN_FAILURE",
  LOGOUT: "AUTH_LOGOUT",
  GET_USER_REQUEST: "AUTH_GET_USER_REQUEST",
  GET_USER_SUCCESS: "AUTH_GET_USER_SUCCESS",
  GET_USER_FAILURE: "AUTH_GET_USER_FAILURE",
  CHANGE_PASSWORD_REQUEST: "AUTH_CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_SUCCESS: "AUTH_CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "AUTH_CHANGE_PASSWORD_FAILURE",
};